/* Zaviyaar theme — consolidated UI behaviour (no modules, Shopify-flat-asset safe). */
(function () {
  'use strict';
  var doc = document;
  var body = doc.body;

  function on(el, ev, fn, opt) { if (el) el.addEventListener(ev, fn, opt || false); }
  function all(sel, root) { return Array.prototype.slice.call((root || doc).querySelectorAll(sel)); }

  /* ---------- overlay controller: mobile nav, search, cart drawer, modals ---------- */
  var scrim = doc.querySelector('[data-scrim]');
  var openEl = null;
  var lastFocus = null;

  function lock() { body.classList.add('is-locked'); }
  function unlock() { body.classList.remove('is-locked'); }

  function openOverlay(el) {
    if (!el) return;
    if (openEl) closeOverlay();
    openEl = el;
    lastFocus = doc.activeElement;
    el.classList.add('is-open');
    el.setAttribute('aria-hidden', 'false');
    if (scrim) scrim.classList.add('is-open');
    lock();
    var focusTarget = el.querySelector('[data-autofocus]') || el.querySelector('button, a, input');
    if (focusTarget) setTimeout(function () { focusTarget.focus(); }, 60);
  }
  function closeOverlay() {
    if (!openEl) return;
    openEl.classList.remove('is-open');
    openEl.setAttribute('aria-hidden', 'true');
    if (scrim) scrim.classList.remove('is-open');
    unlock();
    if (lastFocus) try { lastFocus.focus(); } catch (e) {}
    openEl = null;
  }

  on(doc.querySelector('[data-nav-open]'), 'click', function () { openOverlay(doc.getElementById('mobile-nav')); });
  on(doc.querySelector('[data-search-open]'), 'click', function () { openOverlay(doc.getElementById('search-panel')); });
  var cartOpenBtn = doc.querySelector('[data-cart-open]');
  on(cartOpenBtn, 'click', function (e) { e.preventDefault(); openOverlay(doc.getElementById('cart-drawer')); });

  all('[data-overlay-close]').forEach(function (btn) { on(btn, 'click', closeOverlay); });
  on(scrim, 'click', closeOverlay);
  on(doc, 'keydown', function (e) { if (e.key === 'Escape') closeOverlay(); });

  /* ---------- announcement dismiss ---------- */
  var ann = doc.querySelector('[data-announcement]');
  on(doc.querySelector('.announcement-close'), 'click', function () { if (ann) ann.setAttribute('hidden', ''); });

  /* ---------- sticky header shadow on scroll ---------- */
  var header = doc.querySelector('.site-header');
  function onScroll() { if (header) header.classList.toggle('is-scrolled', window.scrollY > 8); }
  on(window, 'scroll', onScroll, { passive: true }); onScroll();

  /* ---------- desktop mega menu (hover + focus, Escape) ---------- */
  all('.primary-nav > li').forEach(function (li) {
    var mega = li.querySelector('.mega');
    var link = li.querySelector('.nav-link');
    if (!mega || !link) return;
    function open() { mega.classList.add('is-open'); link.setAttribute('aria-expanded', 'true'); }
    function close() { mega.classList.remove('is-open'); link.setAttribute('aria-expanded', 'false'); }
    on(li, 'mouseenter', open);
    on(li, 'mouseleave', close);
    on(li, 'focusin', open);
    on(li, 'focusout', function (e) { if (!li.contains(e.relatedTarget)) close(); });
  });

  /* ---------- mobile nav collapsible groups ---------- */
  all('.mobile-nav-panel .m-head').forEach(function (h) {
    if (h.tagName !== 'BUTTON') return;
    on(h, 'click', function () {
      var ex = h.getAttribute('aria-expanded') === 'true';
      h.setAttribute('aria-expanded', ex ? 'false' : 'true');
    });
  });

  /* ---------- generic accordions (FAQ, PDP) ---------- */
  all('.accordion-trigger').forEach(function (t) {
    on(t, 'click', function () {
      var ex = t.getAttribute('aria-expanded') === 'true';
      t.setAttribute('aria-expanded', ex ? 'false' : 'true');
    });
  });

  /* ---------- reveal on scroll ---------- */
  var reveals = all('.reveal');
  if ('IntersectionObserver' in window && reveals.length) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (en.isIntersecting) { en.target.classList.add('is-in'); io.unobserve(en.target); }
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });
    reveals.forEach(function (r) { io.observe(r); });
  } else {
    reveals.forEach(function (r) { r.classList.add('is-in'); });
  }

  /* ---------- product card colour swatch → swap lead image ---------- */
  all('.product-card').forEach(function (card) {
    var img = card.querySelector('.product-card-media img');
    all('.swatch-dot', card).forEach(function (dot) {
      on(dot, 'mouseenter', function () {
        var src = dot.getAttribute('data-img');
        if (src && img) img.src = src;
      });
    });
  });
})();
